import { Vue, Component, Ref, Prop, Emit } from 'vue-property-decorator'
import { cloneDeep } from 'lodash'
import { ConfigurationCaseValidationSituationConfigurationCreateRequest, ConfigurationCaseValidationSituationConfigurationPatchInBatchRequest, ConfigurationCaseValidationSituationConfigurationResponse } from '@/modules/configurationModule/detail/local-cases/local-case-validation-situations/services/local-case-validation-situations.dto'
import { initialLocalCasesValidationSituationsModalState, LocalCasesValidationSituationModalItemList, LocalCasesValidationSituationModalState } from '@/modules/configurationModule/detail/local-cases/local-case-validation-situations/components/local-case-validation-situations-modal/local-case-validation-situations-modal.model'
import { caseValidationSituationConfigurationService } from '@/modules/configurationModule/detail/local-cases/local-case-validation-situations/services/case-validation-situation.service'
import { caseValidationActionConfigurationService } from '@/modules/configurationModule/detail/local-cases/local-case-validation-situations/services/case-validation-action.service'
import { EnumResponse } from '@/api/services/common.dto'
import { Nullable } from '@/shared/types/app.types'

@Component
export default class LocalCaseValidationSituationsModal extends Vue {
    @Ref() readonly localCaseSituationValidationsModal!: any
    @Prop(String) readonly actionTitle!: string
    @Prop(Number) readonly labId!: number
    @Emit()
    update(caseTypePatch: ConfigurationCaseValidationSituationConfigurationPatchInBatchRequest[]): ConfigurationCaseValidationSituationConfigurationPatchInBatchRequest[] {
        return caseTypePatch
    }
    @Emit()
    create(caseTypeCreate: ConfigurationCaseValidationSituationConfigurationCreateRequest): ConfigurationCaseValidationSituationConfigurationCreateRequest {
        return caseTypeCreate
    }

    state: LocalCasesValidationSituationModalState
    constructor() {
        super()
        this.state = initialLocalCasesValidationSituationsModalState()
    }

    get canEdit(): boolean {
        return !this.state.selectedRow?.id
    }

    get canUpdate(): boolean {
        const actionOk = !!this.state.validationAction.selected?.id
        const situationOk = !!this.state.validationSituation.selected?.id
        const anyComboDirty = this.$_someFieldIsDirty(this.fields)
        return actionOk && situationOk && anyComboDirty
    }

    async show(selectedRow: Nullable<ConfigurationCaseValidationSituationConfigurationResponse>): Promise<void> {
        this.state = initialLocalCasesValidationSituationsModalState()
        await this._getValidationSituation()
        await this._getValidationActions()
        await this.$validator.reset()
        if (selectedRow) {
            this._setSelectedRow(selectedRow)
            this._findPreselections()
        }
        this._showModal()
    }

    hide(): void { this.localCaseSituationValidationsModal.hide() }

    spreadEvent(): void {
        if (this.state.selectedRow?.id) {
            const updatedValue: ConfigurationCaseValidationSituationConfigurationPatchInBatchRequest = {
                id: this.state.selectedRow?.id,
                validationAction: this.state.validationAction.selected?.id as string
            }
            this.update([updatedValue])
            return
        }
        const createValue: ConfigurationCaseValidationSituationConfigurationCreateRequest = {
            validationAction: this.state.validationAction.selected?.id as string,
            validationSituation: this.state.validationSituation.selected?.id as string
        }
        this.create(createValue)
    }

    updateRow(selectedRow: Nullable<ConfigurationCaseValidationSituationConfigurationResponse>): void {
        this._setSelectedRow(selectedRow)
    }

    private async _getValidationSituation(): Promise<void> {
        const [err, response] = await this.$_toCall(caseValidationSituationConfigurationService.getCaseValidationSituations())
        if (err) {
            this.state.validationSituation.data = []
        }
        this.state.validationSituation.data = response.map((validationSituation: EnumResponse) => {
            return {
                id: validationSituation.code,
                text: validationSituation.translatedName
            }
        })
    }

    private async _getValidationActions(): Promise<void> {
        const [err, response] = await this.$_toCall(caseValidationActionConfigurationService.getCaseValidationActions())
        if (err) {
            this.state.validationAction.data = []
        }
        this.state.validationAction.data = response.map((validationAction: EnumResponse) => {
            return {
                id: validationAction.code,
                text: validationAction.translatedName
            }
        })
    }

    private _setSelectedRow(selectedRow: Nullable<ConfigurationCaseValidationSituationConfigurationResponse>): void {
        const updateRow = cloneDeep(selectedRow)
        this.state = {
            ...this.state,
            selectedRow: updateRow
        }
    }

    private _findPreselections(): void {
        const foundAction = this.state.validationAction.data.find((action: LocalCasesValidationSituationModalItemList) => action.id === this.state.selectedRow?.validationAction.code)
        const foundSituation = this.state.validationSituation.data.find((action: LocalCasesValidationSituationModalItemList) => action.id === this.state.selectedRow?.validationSituation.code)
        this.state = {
            ...this.state,
            validationAction: {
                ...this.state.validationAction,
                selected: foundAction || null
            },
            validationSituation: {
                ...this.state.validationSituation,
                selected: foundSituation || null
            }
        }
    }

    private _showModal(): void {
        this.localCaseSituationValidationsModal.show()
    }
}
